/**
 * Move one item within a list by a relative offset (e.g. -1 = up, +1 = down).
 *
 * @template T
 * @param {T[]} items
 * @param {number} fromIndex
 * @param {number} delta
 * @returns {T[]}
 */
export const moveListItem = (items, fromIndex, delta) => {
  const list = Array.isArray(items) ? items : [];
  const toIndex = fromIndex + delta;
  if (fromIndex < 0 || fromIndex >= list.length || toIndex < 0 || toIndex >= list.length) {
    return list;
  }
  const next = [...list];
  const [item] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, item);
  return next;
};
